// extracted by mini-css-extract-plugin
export default {"cursed":"header_cursed__-hP6O"};